module.exports = __webpack_public_path__ + "img/TV_clean_box08.47b62768.jpg";